module.exports = __webpack_public_path__ + "01_bob_grey.0df17ec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_bob_grey.png
// module id = uoX6
// module chunks = 0